import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import Banner from "@/components/Banner.vue";
import AdvertPanel from "@/components/AdvertPanel/index.vue";
import FloatingContact from "@/components/FloatingContact.vue";
import avatar from "../assets/contact-female-avatar.png";
import { useStore } from "@/store";

export default /*#__PURE__*/_defineComponent({
  __name: 'Cooperation',
  setup(__props) {

const store = useStore();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Banner, {
      src: "https://www.szjfjt.com/images/fbz.jpg",
      style: {"height":"100px"},
      href: "https://www.fbz.com/",
      show: ""
    }),
    _createVNode(AdvertPanel),
    (_unref(store).state.contacts)
      ? (_openBlock(), _createBlock(FloatingContact, {
          key: 0,
          title: "官方合作",
          qq: _unref(store).state.contacts[0],
          avatar: _unref(avatar)
        }, null, 8, ["qq", "avatar"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})